import { type ResourcesConfig } from 'aws-amplify';

const isPasswordFlowActive =
  process.env.REACT_APP_IS_PASSWORD_FLOW_ACTIVE === 'true';

const config: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID!,
      userPoolClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID!,
      identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID!,
      ...(!isPasswordFlowActive && {
        loginWith: {
          oauth: {
            domain: process.env.REACT_APP_COGNITO_DOMAIN!.slice(8), // remove protocol (https://) from the domain
            redirectSignIn: [process.env.REACT_APP_COGNITO_REDIRECT_URI!],
            redirectSignOut: [],
            responseType: 'code',
            scopes: [],
          },
        },
      }),
    },
  },
  Analytics: {
    KinesisFirehose: {
      region: 'eu-central-1',
      flushInterval: 500,
    },
  },
};

export default config;
